import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { GetUserRankQueryHandler, GetUserRankQueryResult } from '../../application/handlers';
import { AppRoutes } from '@core';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { toSignal } from '@angular/core/rxjs-interop';
import { OrIconComponent } from '@ui-components';

@Component({
  selector: 'lib-player-rank',
  templateUrl: './player-rank.component.html',
  styleUrls: ['./player-rank.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, OrIconComponent],
  providers: [GetUserRankQueryHandler]
})
export class PlayerRankComponent {
  private readonly getUserRankQueryHandler: GetUserRankQueryHandler = inject(GetUserRankQueryHandler);
  private readonly router: Router = inject(Router);

  readonly userRank: Signal<GetUserRankQueryResult | undefined> = toSignal(this.getUserRankQueryHandler.getUserRank());

  goToRank(): void {
    this.router.navigateByUrl(`${AppRoutes.RANK}`);
  }

  calculateProgressBarValue(userRank: GetUserRankQueryResult): number {
    return 1 - (userRank.rank - 1) / (userRank.totalUsers - 1);
  }
}
